// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2TsE8","main-image":"Header_main-image__1KOK-"};